import { render, staticRenderFns } from "./RedeemPointsComponent.vue?vue&type=template&id=e0ffb06e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./RedeemPointsComponent.vue?vue&type=script&lang=js&"
export * from "./RedeemPointsComponent.vue?vue&type=script&lang=js&"
import style0 from "./RedeemPointsComponent.vue?vue&type=style&index=0&id=e0ffb06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ffb06e",
  null
  
)

component.options.__file = "RedeemPointsComponent.vue"
export default component.exports